import { resolveUrl } from '@wix/metro-runtime';
function resolveWixHeadlessV1RedirectSessionServiceUrl(opts) {
    const domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/redirects-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/redirects-api',
                destPath: '',
            },
            {
                srcPath: '/redirect-session',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/**
 * Creates a URL for redirecting a visitor from an external client site to a Wix page for Wix-managed functionality.
 *
 *
 * The `createRedirectSession()` function enables your external Wix Headless client site, built on any platform, to integrate Wix-managed frontend functionality for specific processes.
 * For example, your site can temporarily redirect a visitor to Wix for authentication, or for a checkout process for a bookings, eCommerce, events, or paid plans transaction.
 *
 * To initiate a redirect session:
 *
 * 1. Call `createRedirectSession()` with the details required for Wix to take care of one specific process (for example, authentication or a bookings checkout). Provide one or more callback URLs, so Wix can redirect the user back to your site as appropriate when the process is over.
 * 1. Redirect your visitor to the URL provided in the response. This URL includes query parameters informing Wix where to redirect the visitor back to on your external site.
 * 1. Make sure the pages at the callback URLs you provided take care of the next stages in your visitor flow.
 */
export function createRedirectSession(payload) {
    function __createRedirectSession({ host }) {
        const metadata = {
            entityFqdn: 'wix.headless.v1.redirect_session',
            method: 'POST',
            methodFqn: 'wix.headless.v1.RedirectSessionService.CreateRedirectSession',
            url: resolveWixHeadlessV1RedirectSessionServiceUrl({
                protoPath: '/v1/redirect-session',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __createRedirectSession;
}
//# sourceMappingURL=headless-v1-redirect-session-redirects.http.js.map